import React, { useEffect, useMemo, useState } from 'react';
import { Box, makeStyles } from '@material-ui/core';
import { useSelector } from 'react-redux';
import _, { isArray } from 'lodash';
import Text from '../../../../../../../components/Text';
import { AutoCompleteInput } from '../../../../../../../components';
import StyleButton from '../../../../../../../components/StyleButton';
import { bedStatusAPI } from '../../../../../../../apis';
import { useGetUserInfo } from '../../../../../../../utils';

const WardCodeMapping = ({ enableOrderService, handleSuccess }) => {
  const classes = useStyles({ enableOrderService });
  const rouList = useSelector((state) => state.rouList);
  const [wardCodings, setWardCodings] = useState([]);
  const [adsList, setAdsList] = useState([]);
  const userInfo = useGetUserInfo();

  const handleSelectAdsLocation = (key) => (location) => {
    setWardCodings((prevValues) =>
      prevValues.map((item) => {
        if (`${item.ccHospitalCode} ${item.ccWardLocation} ${item.ccWardCd}` === key) {
          return {
            ...item,
            location,
          };
        }
        return item;
      })
    );
  };

  const getADSList = async () => {
    try {
      const { result } = await bedStatusAPI.getOrderLocationList({ hospitalCode: userInfo.hospCode });
      setAdsList(result?.ADSInfoDetails);
    } catch (error) {
      console.log(error);
    }
  };

  const getWardCodingDetail = async () => {
    try {
      const { result } = await bedStatusAPI.getWardCodingDetail();
      setWardCodings(result?.wardCodings);
    } catch (error) {
      console.log(error);
    }
  };

  const updateWardCodingDetail = async () => {
    try {
      const params = {
        wardCodings: _.map(wardCodings, (item) => ({
          ...item,
          locationDesc: _.find(adsItemList, (adsItem) => adsItem.value === item.location)?.text,
        })),
      };

      await bedStatusAPI.updateWardCodingDetail(params);
      handleSuccess();
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getWardCodingDetail();
    getADSList();
  }, [rouList]);

  const adsItemList = useMemo(() => {
    if (isArray(adsList) && adsList.length > 0) {
      return _.map(adsList, (item) => ({
        text: item.locationDesc,
        value: item.locationCode,
      }));
    }
    return [];
  }, [adsList]);

  return (
    <Box className={classes.disabled} display="flex" flexDirection="column" flex={1} justifyContent="space-between">
      <Box>
        <Text color="#333333" fontSize="1.5rem" fontWeight="700">
          Ward Coding Mapping
        </Text>
        <Box display="flex" mt="1.875rem">
          <Box display="flex" flexDirection="column">
            <Text color="#538FFF" fontSize="1rem" fontWeight="700" mr="3.75rem" textTransform="uppercase">
              Hosp, Ward Loc. & Code
            </Text>
            {wardCodings.map((item) => (
              <Box
                display="flex"
                alignItems="center"
                pt="1rem"
                pb="1rem"
                borderBottom="1px solid #E4E7EB"
                key={`${item.ccWardLocation} ${item.ccWardCd}`}
              >
                <Text color="#2E4469" fontSize="1.125rem" lineHeight="3.5rem">
                  {`${item.ccHospitalCode} ${item.ccWardLocation} ${item.ccWardCd}`}
                </Text>
              </Box>
            ))}
          </Box>
          <Box display="flex" flexDirection="column" flex="auto">
            <Text color="#538FFF" fontSize="1rem" fontWeight="700" textTransform="uppercase">
              Location @ ADS / Local System
            </Text>
            {wardCodings.map((item) => (
              <Box pt="1rem" pb="1rem" borderBottom="1px solid #E4E7EB" key={`${item.ccWardLocation} ${item.ccWardCd}`}>
                <AutoCompleteInput
                  height="3.5rem"
                  itemList={adsItemList}
                  value={item.location}
                  onChange={handleSelectAdsLocation(`${item.ccHospitalCode} ${item.ccWardLocation} ${item.ccWardCd}`)}
                />
              </Box>
            ))}
          </Box>
        </Box>
      </Box>
      <Box display="flex" alignItems="center" justifyContent="center" p="2rem">
        <StyleButton text="Save" type="fill" onClick={updateWardCodingDetail} />
      </Box>
    </Box>
  );
};
const useStyles = makeStyles(() => ({
  disabled: ({ enableOrderService }) =>
    enableOrderService
      ? {}
      : {
          pointerEvents: 'none',
          opacity: 0.5,
        },
}));

export default WardCodeMapping;
